export const urlReplacer = (str: string, mapObj: { [key: string]: any }) => {
  // eslint-disable-next-line
  const re = new RegExp(
    Object.keys(mapObj)
      .map((i) => ":" + i)
      .join("|"),
    "gi",
  );
  return str.replace(re, (matched) => mapObj[matched.replace(":", "")]);
};
export const compare = function (obj1, obj2) {
  for (let p in obj1) {
    //Check property exists on both objects
    if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) return false;

    switch (typeof obj1[p]) {
      //Deep compare objects
      case "object":
        if (!compare(obj1[p], obj2[p])) return false;
        break;
      //Compare function code
      case "function":
        if (
          typeof obj2[p] === "undefined" ||
          (p !== "compare" && obj1[p].toString() !== obj2[p].toString())
        )
          return false;
        break;
      //Compare values
      default:
        if (obj1[p] !== obj2[p]) return false;
    }
  }

  //Check object 2 for any extra properties
  for (let p in obj2) {
    if (typeof obj1[p] == "undefined") return false;
  }
  return true;
};

function deepen(o) {
  let oo = {},
    t,
    parts,
    part;
  for (let k in o) {
    t = oo;
    parts = k.split(".");
    let key = parts.pop();
    while (parts.length) {
      part = parts.shift();
      t = t[part] = t[part] || {};
    }
    t[key] = o[k];
  }
  return oo;
}

export function normalizePhoneNumber(value) {
  if (!value) {
    return value;
  }
  return value.replace(/[^\d+]+/g, "").replace(/^00/, "+");
}

export const mutateErrors = (e: any) => {
  if (e?.response?.data?.errors) {
    let firstErrorsOnly = {};
    Object.keys(e.response.data.errors).forEach((key) => {
      firstErrorsOnly[key] = e.response.data.errors[key][0];
    });
    return {
      errors: deepen(firstErrorsOnly),
      message: e?.response?.data?.message || "Something went wrong",
    };
  } else if (e?.response?.data?.message) {
    return {
      errors: {},
      message: e.response.data.message,
    };
  } else if (typeof e === "string") {
    return {
      errors: {},
      message: e,
    };
  } else {
    return {
      errors: {},
      message: "Something went wrong",
    };
  }
};

export const formatWithCommas = (num: number) =>
  String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const createObject = (obj, path, val) => {
  const keys = path.split(".");
  const lastKey = keys.pop();
  const lastObj = keys.reduce((obj, key) => (obj[key] = obj[key] || {}), obj);
  lastObj[lastKey] = val;
};

export function capitalize(value: string) {
  if (typeof value !== "string") return "";

  return value.charAt(0).toUpperCase() + value.slice(1);
}

export const removeRedundantKeys = (data: object): object => {
  const cleared = {};

  const keys = Object.keys(data);

  keys.forEach((key) => {
    if (key[0] !== "_") {
      cleared[key] = data[key];
    }
  });

  return cleared;
};

export const cleanObj = (data: object): object => {
  const cleared = {};

  const keys = Object.keys(data);

  keys.forEach((key) => {
    if (data[key] !== undefined) {
      cleared[key] = data[key];
    }
  });

  return cleared;
};

export function sortArray<K>(
  arr: K[],
  key: string,
  direction: string = "asc",
): K[] {
  return arr.sort((firstObj, secondObj) => {
    if (firstObj[key] < secondObj[key]) {
      return direction === "asc" ? -1 : 1;
    }

    if (firstObj[key] > secondObj[key]) {
      return direction === "asc" ? 1 : -1;
    }

    return 0;
  });
}
